<script setup lang="ts">
import { RouterView } from 'vue-router';
import Toast from 'primevue/toast';
import ConfirmDialog from 'primevue/confirmdialog';
</script>

<template>
  <RouterView />
  <Toast position="top-right" />
  <ConfirmDialog />
</template>

<style>
:root {
  color-scheme: light;
  font-family: system-ui, -apple-system, 'Segoe UI', sans-serif;
}

body,
html,
#app {
  margin: 0;
  padding: 0;
  height: 100%;
}

/*
 * Global: action-кнопки не должны схлопывать подпись по буквам, когда flex-
 * контейнер шапки/панели зажат. Без этого правила PrimeVue label переносится
 * посимвольно и кнопки выглядят «обрезанными». Подпись держим в одну строку;
 * при нехватке места кнопка переносится целиком (контейнеры используют
 * flex-wrap).
 */
.p-button {
  white-space: nowrap;
  /* Кнопки не сжимаются уже своего текста: в зажатых flex-рядах подпись
     иначе обрезается по центру. При нехватке места ряды переносят кнопки
     целиком (контейнеры используют flex-wrap). */
  flex-shrink: 0;
}

.p-button .p-button-label {
  white-space: nowrap;
}
</style>
